import React, { useState, useEffect } from "react"
import Select from "react-select"
import Modal from "react-modal"
import { ResponsiveTable, InfoModal, MobileImportantMessage } from "pharedata-responsive-components"

import { SingleOption, customStyles, parseBudat, getLocaleStringNumber, getNumberFromLocalString, getLocaleStringFloat } from "../../utils/utils.js"
import { getAlertIconVentas } from "../../utils/get"
import { getMaterialTitleCierre } from "../../utils/materiales"
import { showGreyBackground, hideGreyBackground, scrollTo } from "../../utils/windows.js"
import { customModalStyles } from "../../utils/styles.js";

import closeIcon from "../../../assets/img/cross-icon.svg"

const modalStyles = customModalStyles(20)
modalStyles.content.padding = 0

const mobileColumns = [
  {"header": "Tanque", "key": "tanque", "showDetailArrow": false},
  {"header": "Material", "key": "material", "showDetailArrow": false},
  {"header": "Diferencia", "key": "diferencia", "showDetailArrow": true}
]

const tabletColumns = [
  {"header": "Tanque", "key": "tanque", "showDetailArrow": false},
  {"header": "Material", "key": "material", "showDetailArrow": false},
  {"header": "Salida Litros", "key": "salidas", "showDetailArrow": false},
  {"header": "Entrada Litros", "key": "entradas", "showDetailArrow": false},
  {"header": "Diferencia", "key": "diferencia", "showDetailArrow": false}
]

const modalColumns = [
  {"header": "Detalle Tanques", "key": "detalle", "showDetailArrow": false},
  {"header": "Cantidad", "key": "cantidad", "showDetailArrow": false}
]

const sifones = ["SIFON_1", "SIFON_2", "SIFON_3"]

export const CalibracionesMobile = ({ configuracion, calibracionesEntradas, calibracionesSalidas, getTotal, medicionesChange, entradasFocusOut }) => {
  const [dataForTable, setDataForTable] = useState([])
  const [showTanque, setShowTanque] = useState()

  useEffect(() => {
    if(configuracion && configuracion.TANQUES){
      const newDataArr = []
  
      configuracion.TANQUES.forEach(function(tanque, key){
        const newData = getTanquesCalibracion(key)
        if(newData)
          newDataArr.push(newData)
      })

      const newData = {
        "tanque": "Total General",
        "material": "",
        "entradas": getLocaleStringFloat(getTotal(calibracionesEntradas)),
        "salidas": getLocaleStringFloat(getTotal(calibracionesSalidas)),
        "diferencia": getLocaleStringFloat(getTotal(calibracionesEntradas) - getTotal(calibracionesSalidas))
      }

      newDataArr.push(newData)
      setDataForTable(newDataArr)
    }
  }, [configuracion, calibracionesEntradas, calibracionesSalidas])

  const closeModal = () => {
    setShowTanque()
    hideGreyBackground()
  }

  const getCalibracionesEntradasSalidas = (tipo, id) => {
    const entradas = getNumberFromLocalString(calibracionesEntradas[id]) || 0
    const salidas = getNumberFromLocalString(calibracionesSalidas[id]) || 0

    if(tipo === "entradas"){
      if(id === "TOTAL")
        return getLocaleStringFloat(getTotal(calibracionesEntradas))
      return calibracionesEntradas[id] || 0
    }
    else if(tipo === "salidas"){
      if(id === "TOTAL")
        return getLocaleStringFloat(getTotal(calibracionesSalidas))
      return getLocaleStringFloat(salidas)
    }
    else if(tipo === "diferencia"){
      if(id === "TOTAL")
        return getLocaleStringFloat(getTotal(calibracionesEntradas) - getTotal(calibracionesSalidas))

      return getLocaleStringFloat(entradas - salidas)
    }
  }

  const showDetalle = (tanque) => {
    if(tanque.tanque === "Total General"){
      const newTanque = {
        ID: "TOTAL",
        material:  "Total General",
        SIFON_1: "",
        SIFON_2: "",
        SIFON_3: ""
      }
      setShowTanque(newTanque)
    }

    else{
      setShowTanque(tanque)
    }

    scrollTo(0, 0)
    showGreyBackground()
  }

  function getTanquesCalibracion(key){
    const tanque = configuracion.TANQUES[key]
    if(parseInt(tanque.ID) > parseInt(tanque.SIFON_1) || parseInt(tanque.ID) > parseInt(tanque.SIFON_2))
      return

    if (tanque.TIPO==="camion")
      return

    let tanqueName = "Tanque " + tanque.ID.split('-')[0]
    let totalEntradas = getNumberFromLocalString(calibracionesEntradas[tanque.ID]) || 0
    let totalSalidas = getNumberFromLocalString(calibracionesSalidas[tanque.ID]) || 0

    sifones.forEach(function(sifonKey){
      if(tanque[sifonKey] && tanque[sifonKey] !== ""){
        tanqueName = tanqueName + " - " + tanque[sifonKey].split('-')[0]
        totalEntradas += getNumberFromLocalString(calibracionesEntradas[tanque[sifonKey]]) || 0
        totalSalidas += getNumberFromLocalString(calibracionesSalidas[tanque[sifonKey]]) || 0
      }
    })

    let totalDiferencia = totalEntradas - totalSalidas
    totalDiferencia = getLocaleStringFloat(totalDiferencia)

    tanque.tanque = tanqueName
    tanque.material = getMaterialTitleCierre(tanque.ID_MATERIAL)
    tanque.entradas = totalEntradas
    tanque.salidas = totalSalidas
    tanque.diferencia = totalDiferencia

    return tanque
  }

  return (
    <div className="hide-desktop">
      <div className="show-only-mobile">
        <MobileImportantMessage
          message="La diferencia total de calibraciones debe ser cero."
        />
      </div>
      <div className="big-subtitle">
        Calibraciones
        <hr className="title-separator-line" />
      </div>
      <div>
        <ResponsiveTable 
          columns={mobileColumns}
          data={dataForTable}
          showDetailFunction={showDetalle}
        />
      </div>

      {showTanque &&
        <Modal
          isOpen={true}
          onRequestClose={closeModal}
          style={modalStyles}
          className="responsive-modal"
        >
          <div className="mobile-filters__title responsive-filters">
            <h1 className="responsive-modal-title">Calibraciones</h1>
            <button className="mobile-filters__close-btn" onClick={closeModal}>
              <img src={closeIcon} alt="close modal" />
            </button>
            <div className="responsive-modal-subtitle-cc">
              {showTanque.material}
            </div>
          </div>
          <div className="mobile-filters__main-section">
            <div className="mobile-title">
              Salida Litros
            </div>
            <div className="mobile-disabled-input">{getCalibracionesEntradasSalidas("salidas", showTanque.ID)}</div>

            <div className="mobile-title-extra-space">
              Entrada Litros
            </div>
            {showTanque.ID !== "TOTAL" &&
              <input
                className="mobile-input"
                type="text" 
                onChange={(e) => medicionesChange(e.target.value, showTanque.ID, 'entradas')}
                value={getCalibracionesEntradasSalidas("entradas", showTanque.ID) || 0}
                onBlur={(e) => entradasFocusOut(e.target.value, showTanque.ID)}
              />
            }
            {showTanque.ID === "TOTAL" &&
              <div className="mobile-disabled-input">{getCalibracionesEntradasSalidas("entradas", showTanque.ID)}</div>
            }

            <div className="mobile-title-extra-space">
              Diferencia Tanque {showTanque.ID}
            </div>
            <div className="mobile-disabled-input">{getCalibracionesEntradasSalidas("diferencia", showTanque.ID)}</div>

            {sifones.map((sifon) => showTanque[sifon] !== "" &&
              <>
                <div className="mobile-title-extra-space">
                  Salida Litros Tanque {showTanque[sifon]}
                </div>
                <div className="mobile-disabled-input">{getCalibracionesEntradasSalidas("salidas", showTanque[sifon])}</div>

                <div className="mobile-title-extra-space">
                  Entrada Litros Tanque {showTanque[sifon]}
                </div>
                <input
                  className="mobile-input"
                  type="text" 
                  onChange={(e) => medicionesChange(e.target.value, showTanque[sifon], 'entradas')}
                  value={getCalibracionesEntradasSalidas("entradas", showTanque[sifon])}
                  onBlur={(e) => entradasFocusOut(e.target.value, showTanque[sifon])}
                />

                <div className="mobile-title-extra-space">
                  Diferencia Tanque {showTanque[sifon]}
                </div>
                <div className="mobile-disabled-input">{getCalibracionesEntradasSalidas("diferencia", showTanque[sifon])}</div>
              </>
            )}
          </div>
          <div className="mobile-filters__footer">
            <button className="main-button" onClick={closeModal}>
              {showTanque.ID !== "TOTAL"? "Guardar": "Cerrar"}
            </button>
          </div>
        </Modal>
      }
      <hr className="mobile-sections-separator show-only-mobile" />
    </div>
  )
}
